import React from 'react';
import { useMessageContext } from '../../../../utils/messageContext';
import { DeletedMessageLayout } from '../../../../components/DeletedMessageLayout';
import { UserNameContainer } from '../UserNameContainer/UserNameContainer';
import { ChatMessageMetaContainer } from '../ChatMessageMetaContainer';

export const DeletedMessageContainer = () => {
  const {
    messageType,
    message: { message: text, isDeleted },
    messageRef,
    isLastInChain,
    userColor,
    highlighted,
    onHighlightEnd,
  } = useMessageContext();

  if (!isDeleted) {
    return null;
  }

  return (
    <DeletedMessageLayout
      messageType={messageType}
      isLastMessageInChain={isLastInChain}
      messageMeta={<ChatMessageMetaContainer />}
      userColor={userColor}
      userName={<UserNameContainer />}
      ref={messageRef}
      highlighted={highlighted}
      onHighlightEnd={onHighlightEnd}
      deletedMessage={text}
    />
  );
};
